<app-topbar></app-topbar>
<app-sidebar></app-sidebar>

<div class="app-content content">
  <div class="content-wrapper">
    <div class="content-header">
      <div class="page-head">
        <div>
          <h3 class="page-head__title">Dollar Exchange Rate Details</h3>
          <p class="page-head__sub">Review and manage a daily dollar exchange rate.</p>
        </div>
        <div class="page-head__tools">
          <div [ngStyle]="{
              display:
                dailyExchangeDetails?.status === 'approved' ||
                dailyExchangeDetails?.status === 'disapproved'
                  ? 'none'
                  : 'block'
            }">
            <app-edit-dollar-rate-modal (refreshRates)="getDollarRates()"
            [rateId]="$safeNavigationMigration(dailyExchangeDetails?.id)"></app-edit-dollar-rate-modal>
          </div>
          <div [ngStyle]="{
              display:
                dailyExchangeDetails?.status === 'approved' ||
                dailyExchangeDetails?.status === 'disapproved'
                  ? 'none'
                  : 'block'
            }">
            <button [disabled]="
                deleteLoading ||
                dailyExchangeDetails?.status === 'approved' ||
                dailyExchangeDetails?.status === 'disapproved'
              " (click)="deleteRate()" class="btn btn-danger btn-round" style="width: 100px">
              @if (!deleteLoading) {
                <span>
                  Delete <i class="fa fa-trash-o" aria-hidden="true"></i>
                </span>
              }
              @if (deleteLoading) {
                <span>
                  <i class="fa fa-trash-o" aria-hidden="true"></i> Deleting...
                </span>
              }
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="row breadcrumbs-top"></div>

    <div class="content-body">
      <!-- Revenue, Hit Rate & Deals -->
      <div class="row">
        <div class="col-12">
          <div class="row all-details">
            <div class="col-md-6">
              <div class="card-header border-right row" style="height: 100%">
                <div class="col-md-5 heading">Exchange Rate</div>
                <div class="col-md-7 detail">
                  ₦{{ $safeNavigationMigration(dailyExchangeDetails?.rate) | number : "1.2-2" }}
                </div>

                <div class="col-md-5 heading">Status</div>
                <div class="col-md-7 details" style="text-transform: capitalize">
                  {{ dailyExchangeDetails?.status }}
                </div>

                <div class="col-md-5 heading">Uploaded By</div>
                <div class="col-md-7 details">
                  {{ dailyExchangeDetails?.uploader?.name }}
                </div>

                <div class="col-md-5 heading">Approved By</div>
                <div class="col-md-7 detail">
                  {{ dailyExchangeDetails?.approver?.name }}
                </div>

                <div class="col-md-5 heading">Uploaded on</div>
                <div class="col-md-7 details">
                  {{ dailyExchangeDetails?.created_at }}
                </div>

                <div class="col-md-5 heading">Approved Date</div>
                <div class="col-md-7 details">
                  {{ dailyExchangeDetails?.approved_at }}
                </div>
                <div class="col-md-5 heading">Valid To</div>
                <div class="col-md-7 details">
                  {{ dailyExchangeDetails?.valid_to }}
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="card-header border-right no-border row" style="height: 100%">
                <div class="col-md-7 details">
                  @for (admin of data?.admins; track admin) {
                    <div>
                      <a [routerLink]="['/admin', $safeNavigationMigration(admin?.slug)]">{{
                        admin?.name
                      }}</a>
                    </div>
                  }
                </div>
                <div class="col-md-12 details" style="text-transform: capitalize">
                  <button type="button" (click)="postApproveRate('disapproved')" class="btn btn-danger"
                    style="width: 200px" [class.disabled]="
                      dailyExchangeDetails?.status === 'approved' ||
                      dailyExchangeDetails?.status === 'disapproved'
                    " [style.pointerEvents]="
                      dailyExchangeDetails?.status === 'approved' ||
                      dailyExchangeDetails?.status === 'disapproved'
                        ? 'none'
                        : 'auto'
                    ">
                    Disapprove
                    @if (clicked === true) {
                      <i class="icons icon-loading"></i>
                    }
                  </button>
                </div>
                <div class="col-md-12 details" style="text-transform: capitalize">
                  <button type="button" (click)="postApproveRate('approved')" class="btn btn-success"
                    style="width: 200px" [class.disabled]="
                      dailyExchangeDetails?.status === 'approved' ||
                      dailyExchangeDetails?.status === 'disapproved'
                    " [style.pointerEvents]="
                      dailyExchangeDetails?.status === 'approved' ||
                      dailyExchangeDetails?.status === 'disapproved'
                        ? 'none'
                        : 'auto'
                    ">
                    Approve
                    @if (clicked === true) {
                      <i class="icons icon-loading"></i>
                    }
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-bottombar></app-bottombar>